import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-500/15 text-accent-400 text-xs font-medium mb-3 whitespace-nowrap">
            实时热度
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            爆料热度榜
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-xl mx-auto">
            基于阅读量、讨论度和分享数综合计算的热度排名
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="rounded-lg bg-background-100 border border-background-300/50 overflow-hidden">
            {rankingData.map((item, idx) => (
              <a
                key={item.id}
                href="#"
                className={`flex items-center gap-4 px-4 md:px-6 py-4 transition-colors cursor-pointer hover:bg-background-200/50 ${
                  idx < rankingData.length - 1 ? 'border-b border-background-300/50' : ''
                }`}
              >
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 font-bold text-sm ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-900'
                    : item.rank === 2
                    ? 'bg-primary-500/30 text-primary-400'
                    : item.rank === 3
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-foreground-200 text-sm md:text-base font-medium truncate">
                      {item.title}
                    </span>
                    {item.tag && (
                      <span className={`px-1.5 py-0.5 rounded text-xs font-medium flex-shrink-0 whitespace-nowrap ${
                        item.tag === '爆'
                          ? 'bg-primary-500/90 text-foreground-50'
                          : item.tag === '热'
                          ? 'bg-accent-500/20 text-accent-400'
                          : 'bg-secondary-500/20 text-secondary-400'
                      }`}>
                        {item.tag}
                      </span>
                    )}
                  </div>
                </div>

                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className="text-accent-400 font-semibold text-sm whitespace-nowrap">
                    {item.heat}
                  </span>
                  <i
                    className={`text-sm ${
                      item.trend === 'up'
                        ? 'ri-arrow-up-line text-primary-400'
                        : 'ri-arrow-down-line text-foreground-600'
                    }`}
                  ></i>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}